import { Observable } from "rxjs";
import { ICommand } from "../../modules/records/commands/i-command";
import { IApiService } from "../../modules/records/models/api/i-api-service";
import { RecordsManager } from "../../modules/records/records-manager";

export class InfoPlanCommand<
  T extends object & { disabled: boolean },
  S extends IApiService<T> & {
    infoPlan: (el: T) => void;
  }
> implements ICommand<T, S>
{
  private receiver!: RecordsManager<T>;
  type: "primary" | "warn" | "accent" = "accent";
  layout: "flat" | "raised" | "normal" = "raised";
  icon = "info_outline";
  constructor(public service: S) {}
  execute(el: T) {
    this.service.infoPlan(el)
  }

  setReceiver(receiver: RecordsManager<T>) {
    this.receiver = receiver;
  }

  isDisabled(el: T) {
    return  this.receiver.isLoading;
  }
}
